// IMPORTS
// OHS
import { OHSFormItem } from '../../../onehivesystems/js/OHSForm';


// COMPONENT
export default function Log (props) {
   // Functions
   function formatApplicationName (application) {
      return application.charAt(0).toUpperCase() + application.slice(1, 3) + application.charAt(3).toUpperCase() + application.slice(4);
   }

   // Component
   return (
      <div className='auditlogs-list-item'>
         <OHSFormItem onehive={props.onehive} title="Date">
            <p className='auditlogs-list-item-date'>{props.content.created_at.value}</p>
         </OHSFormItem>
         <OHSFormItem onehive={props.onehive} title="User">
            <p className='auditlogs-list-item-user'>{props.content.username.value}</p>
         </OHSFormItem>
         <OHSFormItem onehive={props.onehive} title="Application">
            <p className='auditlogs-list-item-application'>{formatApplicationName(props.content.app.value)}</p>
         </OHSFormItem>
         <OHSFormItem onehive={props.onehive} title="Severity">
            <p className={`auditlogs-list-item-severity auditlogs-list-item-severity-${props.content.severity.value}`}>{props.content.severity.value}</p>
         </OHSFormItem>
         <OHSFormItem onehive={props.onehive} title="Message">
            <textarea className='ohsinput-terminal auditlogs-list-item-message' defaultValue={props.content.message.value} readOnly={true}></textarea>
         </OHSFormItem>
      </div>
   );
}